import { TENANT } from "@types/tenant";

export const BlankTenantData: TENANT = {
  id: 0,
  code: "",
  name: "",
  name_kana: "",
  name_english: "",
  postal_code: "",
  address: "",
  phone_number: "",
  fax_number: "",
  url: "",
  local_auth: true,
  google_auth: false,
  microsoft_365_auth: false,
  require_passcode_for_phonebook: false,
  disable_call_recording: false,
  sip_incom_server: "",
  sip_node_server: "",
  shoppers_cloud_url: "",
};
